import * as angular from "angular";
import * as _ from "lodash";
import {ITimeoutService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {LeanPlanningAlertsService} from "./lean-planning-alerts.factory";
import {LeanPlanningRequestsService} from "./plan-requests.factory";
import {RouteModel} from "../../routes/models/route.model";
import {autonomousRouteDisabledActions, routeActionsByStatus} from "../angular/constants/lean-planning.constant";
import {SplitService} from "../../commons/services/split-service.service";
import {TaskModel} from "../../tasks/models/task.model";
import {ChangeRouteResourceQueryModelModel} from "../../routes/models/change-route-resource-query-model.model";

export class LeanPlanningService {

  printerProvider: string;

  /* @ngInject */
  constructor(private leanPlanningRequestsService: LeanPlanningRequestsService, private bringozLoaderService: BringozLoaderService,
              private leanPlanningAlertsService: LeanPlanningAlertsService, private $timeout: ITimeoutService, private IAMPermissions,
              private splitService: SplitService, private leanPlanningConstants) {
    this.printerProvider = this.splitService.getPrinterProvider();
  }

  getPageableRoutes(params, addTimeOut?) {
    const timeoutLength = addTimeOut ? 3000 : 0;
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.$timeout(timeoutLength).then(() => {
        this.leanPlanningRequestsService.getPageableRoutes(params)
          .then((resolvedRoutes) => {
            resolve(resolvedRoutes);
          })
          .catch((error) => {
            // this.settingsAlertsService.getGeneralTasksError();
            reject(error);
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      })
    });
  }

  assignRouteToAgent(rid: string, agentId: string, assignAll?: boolean) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.assignRouteToAgent(rid, agentId, assignAll)
        .then((resolvedRoutes) => {
          this.leanPlanningAlertsService.assignSuccess();
          resolve(resolvedRoutes);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.assignError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  assignRoutesToAgent(routeIds: string[], agentId: string, assignAllServicesToAgent?: boolean) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.assignRoutesToAgent(routeIds, agentId, assignAllServicesToAgent)
        .then((resolvedRoutes) => {
          this.leanPlanningAlertsService.assignSuccess();
          resolve(resolvedRoutes);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.assignError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  addServicesToRoute(deliveryIds?, routeId?, assignAddedDeliveries?) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.addServicesToRoute(deliveryIds, routeId, assignAddedDeliveries)
        .then((res) => {
          this.leanPlanningAlertsService.addDeliveriesSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.addDeliveriesError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  addServicesToRouteSyncTimeWindow(payload) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.addServicesToRouteSyncTimeWindow(payload)
        .then((res) => {
          this.leanPlanningAlertsService.addDeliveriesSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.addDeliveriesError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  createRouteFromServicesSyncTimeWindow(payload) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.createRouteFromServicesSyncTimeWindow(payload)
        .then((res) => {
          this.leanPlanningAlertsService.addDeliveriesSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.addDeliveriesError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  removeDeliveryFromRoute(serviceIdsToRemove, rid) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.removeDeliveryFromRoute(serviceIdsToRemove, rid)
        .then((res) => {
          this.leanPlanningAlertsService.removeUnpackedSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.removeUnpackedError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  optimizeRoute(routeId) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.optimizeRoute(routeId)
        .then((res) => {
          this.leanPlanningAlertsService.reOptimizeSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.reOptimizeError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateRouteSettings(routeId, route) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.updateRouteSettings(routeId, route)
        .then((res) => {
          this.leanPlanningAlertsService.updateRoutingSettingsSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.updateRoutingSettingsError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  getRouteTaskEta(route, task) {
    var taskAnalysisRef = _.get(route.analysis, task.id, {});
    return _.get(task, 'taskSpec.externalEta') || _.get(taskAnalysisRef, 'eta')
  }

  getRouteTaskEtd(route, task) {
    var taskAnalysisRef = _.get(route.analysis, task.id, {});
    var taskEta = _.get(task, 'taskSpec.externalEta') || _.get(taskAnalysisRef, 'eta');
    var taskServiceTime = _.get(taskAnalysisRef, 'serviceTime');
    return taskServiceTime ? (taskEta + taskServiceTime) : _.get(route.analysis[task.id], 'etd');
  }

  recreateRoute(routeId, resourceAllocationId, allocationInstanceId, supplyResourceSource, allocationTimeWindowId, queries?: ChangeRouteResourceQueryModelModel) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.recreateRoute(routeId, resourceAllocationId, allocationInstanceId, supplyResourceSource, allocationTimeWindowId, queries)
        .then((res) => {
          this.leanPlanningAlertsService.updateResourceSuccess();
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  editBlockedState(routeId, block) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.editBlockedState(routeId, block)
        .then((res) => {
          if (block) {
            this.leanPlanningAlertsService.blockRouteSuccess();
          } else {
            this.leanPlanningAlertsService.unblockRouteSuccess();
          }
          resolve(res);
        })
        .catch((error) => {
          if (block) {
            this.leanPlanningAlertsService.blockRouteError();
          } else {
            this.leanPlanningAlertsService.unblockRouteError();
          }
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  validateAssignment(routeId, block) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.validateAssignment(routeId, block)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  createRoute(payload) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.createRoute(payload)
        .then((res) => {
          this.leanPlanningAlertsService.createOneSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.createOneError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  editGroupSequence(groupId, orderedRouteIds) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.editGroupSequence(groupId, orderedRouteIds)
        .then((res) => {
          this.leanPlanningAlertsService.editGroupSequenceSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.editGroupSequenceError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  editRoutes(data, assignServices?, resetServices?) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.leanPlanningRequestsService.editRoutes(data, assignServices, resetServices)
        .then((res) => {
          this.leanPlanningAlertsService.updateSuccess();
          resolve(res);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.updateError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  getRoutesActionsMap(routes?: RouteModel[]) {
    if (!routes) {
      routes = [];
    }
    const enabledActions = angular.copy(this.leanPlanningConstants.allRoutesActions);

    // if (!routes.length) {
    //   return {};
    // }

    const autonomousLockedRoute = routes.find(r => {
      return !!r.lockActionsInfo?.actionsLocked
    })

    if (!!autonomousLockedRoute && !this.splitService.getDisableEntityLockStateValue()) {
      enabledActions.mergeRoutes = false;
    }

    _.forEach(routes, (r) => {
      const actions = this.getRouteActionsMap(r);
      _.forOwn(actions, (value, key) => {
        if (!value) {
          enabledActions[key] = false;
        }
      })
    })

    return enabledActions;
  }

  private getRouteActionsMap(route: RouteModel) {

    const routeActionsByStatusCopy = angular.copy(routeActionsByStatus);
    let actions = routeActionsByStatusCopy[route.status];

    if (route.lockActionsInfo?.actionsLocked && !this.splitService.getDisableEntityLockStateValue()) {
      autonomousRouteDisabledActions.forEach(key => {
        actions[key] = false;
      })
    }

    // (route.taskListExt || []).forEach((task: TaskModel) => {
    //   if (task.subTasks && (task.taskSpec.purpose === 'StartRoute' || task.taskSpec.purpose === 'EndRoute')) {
    //
    //     const bindingSubTask = _.find(task.subTasks, (st) => {
    //       return _.find(st.actions, (ac) => {
    //         return ac.type === "VehicleBinding";
    //       })
    //     })
    //     if (!bindingSubTask && !route.planningResource) {
    //       actions.updateLogisticVehicle = false;
    //     }
    //   }
    // })

    if (route.supplyResourceSource !== 'Allocation') {
      actions.updateResource = false;
    }

    const hasPrintPermission = this.IAMPermissions.hasPermission('printers.list')

    if (actions.printIkea && hasPrintPermission) {
      const operationTaskIndex = route.routeTaskList?.findIndex(t => t.taskSpec.purpose === 'Operation');
      actions.printIkea = (this.printerProvider === 'Ikea') && (operationTaskIndex === -1);
    } else {
      actions.printIkea = false;
    }

    return actions;
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .service('leanPlanningService', LeanPlanningService);
